import { createStore } from 'vuex'
import auth from './modules/auth'
import storeTransfer from './modules/storeTransfer'

export default createStore({
  state: {
    // アプリケーションの状態
  },
  getters: {
    // 状態から計算された値を取得
  },
  mutations: {
    // 状態を変更するための同期処理
  },
  actions: {
    // 非同期処理や複雑なロジック
  },
  modules: {
    // 状態の分割管理
    auth,
    storeTransfer
  }
})
